import React, { useState } from "react";
import { doGet } from "./common";

const UserContext = React.createContext({ user: null, setUser: null });

function getUserAuth(callback) {
  //console.log("### GetAuth##");
}

function refresh(setUser) {
  doGet(
    "/login/auth",
    {},
    (data) => {
      //console.log(data)
      setUser(data.user);
    },
    false,
    3,
    (data) => {
      setUser(null);
    }
  ).then();
}

function UserContextProvider(props) {
  let [user, setUser] = useState(null);
  if (user == null) {
    refresh(setUser);
  }
  return (
    <UserContext.Provider value={{ user: user, setUser: setUser }}>
      {props.children}
    </UserContext.Provider>
  );
}

let UserContextConsumer = UserContext.Consumer;

// [C]
export { UserContext, UserContextConsumer, UserContextProvider, refresh };
